function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6162 0C19.2731 0 20.6162 1.34315 20.6162 3V13C20.6162 14.6569 19.2731 16 17.6162 16H3.61621C1.95936 16 0.616211 14.6569 0.616211 13V3C0.616211 1.34315 1.95936 0 3.61621 0H17.6162ZM18.6162 5.62479H11.6163C11.064 5.62479 10.4605 5.20507 10.2682 4.68732L9.27043 2H3.61621C3.06393 2 2.61621 2.44772 2.61621 3V13C2.61621 13.5523 3.06393 14 3.61621 14H17.6162C18.1685 14 18.6162 13.5523 18.6162 13V5.62479Z",
  fill: "#4979C0"
});

var SvgDocuments = function SvgDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documents.4caee23b.svg";
export { ForwardRef as ReactComponent };